"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  index: function(carrierId) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/carriers/" + carrierId + "/factoring_assignments/",
      type: "get",
      contentType: "application/json"
    })).then(function(data) {
      DataStoreService.updateStores(data);
      return data;
    });
  }
};
